"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../api.d.ts" />
var agencyRegistration;
(function (agencyRegistration) {
    var controller;
    (function (controller) {
        var SearchController = function () {
            /*@ngInject*/

            function SearchController($scope, $rootScope, $state, SearchService, agentFactory) {
                _classCallCheck(this, SearchController);

                this.loader = {};
                this.eventMessages = ["registeredAgency", "serviceError"];
                this.state = $state;
                this.searchService = SearchService;
                this.agentFactory = agentFactory;
                this.agency = this.agentFactory.getAgency();
                this.agency.cnpj = $state.params["cnpj"];
                // Search CNPJ there's any CNPJ in URL
                this.agency.cnpj && this.searchCNPJ();
            }

            _createClass(SearchController, [{
                key: "redirectToLogin",
                value: function redirectToLogin() {
                    parent.window.location.href = "/Login";
                }
            }, {
                key: "searchCNPJ",
                value: function searchCNPJ() {
                    var _this = this;

                    this.loader.show = true;
                    this.setEventMessages(this.eventMessages, false);
                    this.searchService.searchAgency(this.agency.cnpj).then(function (agency) {
                        if (agency) {
                            _this.setEventMessages(["registeredAgency"], true);
                            _this.state.go("search", _this.agency);
                        } else _this.state.go("search.create", _this.agency);
                    }).catch(function () {
                        _this.setEventMessages(["serviceError"], true);
                        //this.state.go("search", this.agency);
                    }).finally(function () {
                        _this.loader.show = false;
                    });
                }
            }, {
                key: "setEventMessages",
                value: function setEventMessages(messages, state) {
                    var _this2 = this;

                    messages.forEach(function (message) {
                        return _this2[message] = state;
                    });
                }
            }]);

            return SearchController;
        }();

        controller.SearchController = SearchController;
    })(controller = agencyRegistration.controller || (agencyRegistration.controller = {}));
})(agencyRegistration || (agencyRegistration = {}));
angular.module('agencyRegistrationApp').controller('SearchController', agencyRegistration.controller.SearchController);